import { render, staticRenderFns } from "./veStuGraduationJyzbhRuleEdit.vue?vue&type=template&id=0a87879a&scoped=true"
import script from "./veStuGraduationJyzbhRuleEdit.vue?vue&type=script&lang=js"
export * from "./veStuGraduationJyzbhRuleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a87879a",
  null
  
)

export default component.exports